import { Link } from "react-router-dom";

export const AdmissionProcessFullTimeConst = {
  path: "/single-page/admission-process-full-time",
  title: "ПРОЦЕСС ПОСТУПЛЕНИЯ НА ОЧНУЮ ФОРМУ",
  contentJSX: (
    <>
      <p>
        <strong>Malta School of Medicine & Business</strong> делает всё возможное, чтобы процесс поступления был максимально простым и
        удобным для студентов. Вы можете отправить свои документы по электронной почте или воспользоваться онлайн-формой заявки на нашем
        сайте.
      </p>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
      <h2>ШАГ 1. ПОДАЙТЕ ДОКУМЕНТЫ</h2>
      <p>
        <strong>Перечень необходимых документов:</strong>
      </p>
      <ul>
        <li>Паспорт (или другой документ, удостоверяющий личность);</li>
        <li>Аттестат о среднем образовании;</li>
        <li>Диплом бакалавра с приложением (для поступления в магистратуру);</li>
        <li>Заполненная форма заявки.</li>
      </ul>
      <p>После подачи документов вы получите Письмо о зачислении и счёт на оплату обучения на электронную почту.</p>
      <h2>ШАГ 2. ОПЛАТИТЕ ОБУЧЕНИЕ</h2>
      <p>
        После получения Письма о зачислении вам необходимо внести оплату за первый год обучения. Это позволит нам выслать вам официальное
        <strong> Пригласительное письмо</strong>, необходимое для оформления визы.
      </p>
      <p>В письме будут указаны банковские реквизиты. При необходимости мы предоставим отдельный счёт-фактуру.</p>
      <h2>ШАГ 3. ПОЛУЧИТЕ ПРИГЛАШЕНИЕ</h2>
      <p>Если вы — гражданин ЕС, приглашение для получения визы не требуется.</p>
      <p>
        Для иностранных студентов из стран, не входящих в ЕС, <strong>Malta School of Medicine & Business</strong> выдаёт официальное
        Пригласительное письмо на обучение после получения всех необходимых документов:
      </p>
      <ul>
        <li>Копия загранпаспорт;</li>
        <li>Заполненная форма заявки;</li>
        <li>Квитанция об оплате за первый год обучения.</li>
      </ul>
      <p>Приглашение высылается в течение 3–5 недель и подтверждает вашу цель поездки, программу обучения и наличие места проживания.</p>
      <h2>ШАГ 4. ОФОРМЛЕНИЕ СТУДЕНЧЕСКОЙ ВИЗЫ</h2>
      <p>
        Студентам из стран за пределами ЕС необходимо получить <strong>студенческую визу</strong> в консульстве или посольстве Мальты. Мы
        поможем собрать все необходимые документы.
      </p>
      <br />
      <p>
        <strong>Необходимые документы:</strong>
      </p>
      <ul>
        <li>Визовая анкета;</li>
        <li>2 фотографии;</li>
        <li>Загранпаспорт;</li>
        <li>Медицинская страховка;</li>
        <li>Подтверждение проживания на Мальте;</li>
        <li>Финансовые документы;</li>
        <li>Квитанция об оплате обучения;</li>
        <li>Пригласительное письмо от MSMB;</li>
        <li>Подтверждение уровня английского языка;</li>
        <li>Оплата визового сбора.</li>
      </ul>
      <p>Мы сопровождаем студентов на всех этапах оформления визы, чтобы сделать этот процесс быстрым и комфортным.</p>
      <h2>ШАГ 5. ПРИБЫТИЕ НА МАЛЬТУ</h2>
      <p>
        Пожалуйста, отправьте копию ваших билетов минимум за 5 рабочих дней до прибытия. Представитель
        <strong> Malta School of Medicine & Business </strong>
        встретит вас в аэропорту, поможет добраться до места проживания и оформит все необходимые формальности.
      </p>
      <p>В течение первых 1–3 рабочих дней после прибытия вы завершите процедуру зачисления и сможете приступить к обучению.</p>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
      <br />
      <p>
        <strong>Malta School of Medicine & Business — ваш путь к международному образованию и профессиональному успеху!</strong>
      </p>
    </>
  ),
  contentSearch: `
        Malta School of Medicine & Business делает всё возможное, чтобы процесс поступления был максимально простым и удобным для студентов. Вы можете отправить свои документы по электронной почте или воспользоваться онлайн-формой заявки на нашем сайте.
        ШАГ 1. ПОДАЙТЕ ДОКУМЕНТЫ
        Перечень необходимых документов:
        Паспорт (или другой документ, удостоверяющий личность);
        Аттестат о среднем образовании;
        Диплом бакалавра с приложением (для поступления в магистратуру);
        Заполненная форма заявки.
        После подачи документов вы получите Письмо о зачислении и счёт на оплату обучения на электронную почту.
        ШАГ 2. ОПЛАТИТЕ ОБУЧЕНИЕ
        После получения Письма о зачислении вам необходимо внести оплату за первый год обучения. Это позволит нам выслать вам официальное Пригласительное письмо, необходимое для оформления визы.
        В письме будут указаны банковские реквизиты. При необходимости мы предоставим отдельный счёт-фактуру.
        ШАГ 3. ПОЛУЧИТЕ ПРИГЛАШЕНИЕ
        Если вы — гражданин ЕС, приглашение для получения визы не требуется.
        Для иностранных студентов из стран, не входящих в ЕС, Malta School of Medicine & Business выдаёт официальное Пригласительное письмо на обучение после получения всех необходимых документов:
        Копия загранпаспорт;
        Заполненная форма заявки;
        Квитанция об оплате за первый год обучения.
        Приглашение высылается в течение 3–5 недель и подтверждает вашу цель поездки, программу обучения и наличие места проживания.
        ШАГ 4. ОФОРМЛЕНИЕ СТУДЕНЧЕСКОЙ ВИЗЫ
        Студентам из стран за пределами ЕС необходимо получить студенческую визу в консульстве или посольстве Мальты. Мы поможем собрать все необходимые документы.
        Необходимые документы:
        Визовая анкета;
        2 фотографии;
        Загранпаспорт;
        Медицинская страховка;
        Подтверждение проживания на Мальте;
        Финансовые документы;
        Квитанция об оплате обучения;
        Пригласительное письмо от MSMB;
        Подтверждение уровня английского языка;
        Оплата визового сбора.
        Мы сопровождаем студентов на всех этапах оформления визы, чтобы сделать этот процесс быстрым и комфортным.
        ШАГ 5. ПРИБЫТИЕ НА МАЛЬТУ
        Пожалуйста, отправьте копию ваших билетов минимум за 5 рабочих дней до прибытия. Представитель Malta School of Medicine & Business встретит вас в аэропорту, поможет добраться до места проживания и оформит все необходимые формальности.
        В течение первых 1–3 рабочих дней после прибытия вы завершите процедуру зачисления и сможете приступить к обучению.

        Malta School of Medicine & Business — ваш путь к международному образованию и профессиональному успеху!
  `,
};
